import React, { useRef, useContext, useState, useMemo } from 'react'

import OldSelect from '../../components/MiniComponents/OldSelect'
import InputWrapper from '../../components/MiniComponents/InputWrapper'
import FlexWrapper from '../../components/MiniComponents/FlexWrapper'
import Input from '../../components/controls/Input'
import RadioButton from '../../components/MiniComponents/RadioButton'
import CPUFileUpload from '../../components/MiniComponents/CPUFileUpload'
import MonitorFileUpload from '../../components/MiniComponents/MonitorFileUpload'

import { Button, StyledScreen } from './RemoteScreenOne'
import { ModalContext } from '../../context/ModalContext'
import { os, processor, ram, display } from '../../constants/hardwareSpecs'

import { WorkEthicsContext } from '../../context/WorkEthics'

const osNamesBackup = os.map((e) => e.name)

const RemoteScreenThree = () => {
    const { setRemotePage, backupInfra, setBackupInfra, setReachRemotePage, isValidapplicant } =
    useContext(ModalContext)
    const { backupCPUScreenshot, setBackupCPUScreenshot, backupMonitorScreenshot, setBackupMonitorScreenshot } = 
    React.useContext(WorkEthicsContext)

    const safeSetBackupInfra = typeof setBackupInfra === 'function' ? setBackupInfra : () => {};

    const [otherOSBackup, setOtherOSBackup] = useState(false)
    const [otherOSVersionBackup, setOtherOSVersionBackup] = useState(false)
    const [otherProcessorBackup, setOtherProcessorBackup] = useState(false)
    const [otherRAMBackup, setOtherRAMBackup] = useState(false)
    const [otherDisplayBackup, setOtherDisplayBackup] = useState(false)

    const osVersions = useMemo(() => {
        return backupInfra.os
            ? os.filter((e) => e.name === backupInfra.os)[0]?.version
            : os.filter((e) => e.name === osNamesBackup[0])[0]?.version
    }, [backupInfra.os])

    const cpuFileRef = useRef(null)
    const monitorFileRef = useRef(null)

    const handleIsBackupDevice = (e) => {
        const value = e.target.value;
        if (value === 'No') {
            safeSetBackupInfra({
                isBackupDevice: value,
                os: '',
                osVersion: '',
                processor: '',
                ram: '',
                display: '',
            });
            setBackupCPUScreenshot(null);      // Reset CPU file upload
            setBackupMonitorScreenshot(null);  // Reset Monitor file upload
            if (cpuFileRef.current) cpuFileRef.current.clear();
            if (monitorFileRef.current) monitorFileRef.current.clear();
        } else {
            safeSetBackupInfra((prevState) => ({
                ...prevState,
                isBackupDevice: value,
            }));
        }
    }
    const isDeviceNone = backupInfra.isBackupDevice === 'No';

    const handleOtherOS = (e) =>
        safeSetBackupInfra((prevState) => ({
            ...prevState,
            os: e.target.value,
            osVersion: '',
    }))
    const handleSelectOS = (value) => {
        if (value === 'Others') {
            setOtherOSBackup(true)
            safeSetBackupInfra((prevState) => ({
                ...prevState,
                os: value,
                osVersion: '',
            }))
        } else {
            safeSetBackupInfra((prevState) => ({
                ...prevState,
                os: value,
                osVersion: '',
            }))
            setOtherOSBackup(false)
        }
    }
    const handleSelectOSVersion = (value) => {
        if (value === 'Others') {
            setOtherOSVersionBackup(true)
            safeSetBackupInfra((prevState) => ({
            ...prevState,
            osVersion: value,
            }))
        } else {
            safeSetBackupInfra((prevState) => ({
                ...prevState,
                osVersion: value,
            }))
            setOtherOSVersionBackup(false)
        }
    }
    const handleOtherOSVersion = (e) =>
        safeSetBackupInfra((prevState) => ({
            ...prevState,
            osVersion: e.target.value,
    }))
    const handleProcessor = (value) => {
        if (value === 'Others') {
            setOtherProcessorBackup(true)
            safeSetBackupInfra((prevState) => ({ ...prevState, processor: value }))
        } else {
            safeSetBackupInfra((prevState) => ({ ...prevState, processor: value }))
            setOtherProcessorBackup(false)
        }
    }
    const handleOtherProcessor = (e) =>
        safeSetBackupInfra((prevState) => ({
            ...prevState,
            processor: e.target.value,
    }))
    const handleRAM = (value) => {
        if (value === 'Others') {
            setOtherRAMBackup(true)
            safeSetBackupInfra((prevState) => ({ ...prevState, ram: value }))
        } else {
            safeSetBackupInfra((prevState) => ({ ...prevState, ram: value }))
            setOtherRAMBackup(false)
        }
    }
    const handleOtherRAM = (e) =>
        safeSetBackupInfra((prevState) => ({
            ...prevState,
            ram: e.target.value,
    }))
    const handleDisplay = (value) => {
        if (value === 'Others') {
            setOtherDisplayBackup(true)
            safeSetBackupInfra((prevState) => ({ ...prevState, display: value }))
        } else {
            safeSetBackupInfra((prevState) => ({ ...prevState, display: value }))
            setOtherDisplayBackup(false)
        }
    }
    const handleOtherDisplay = (e) =>
        safeSetBackupInfra((prevState) => ({
            ...prevState,
            display: e.target.value,
    }))
    const handleGoBack = () => {
        setRemotePage(1)
        setReachRemotePage(1)
    }
    const handleNext = () => {
        setRemotePage(4)
        setReachRemotePage(4)
    }

    return (
        <StyledScreen>
            <h2 className="subHeading">Backup Infrastructure</h2>
            <p className="paragraph mb-2">
                Share your backup setup to ensure reliable support for working from home
            </p>

            {/* Backup Device */}
            <InputWrapper mt="2.5rem" label="Do you have a Back-up Device?">
            <FlexWrapper
                wrap="wrap"
                gap="1.5rem"
                mobileGap="1rem"
                content="flex-start"
            >
                <RadioButton
                    name="backupDevice"
                    onChange={handleIsBackupDevice}
                    value="Yes - Laptop"
                    label="Yes - Laptop"
                    checked={backupInfra.isBackupDevice === "Yes - Laptop"}
                />
                <RadioButton
                    name="backupDevice"
                    onChange={handleIsBackupDevice}
                    value="Yes - PC"
                    label="Yes - PC"
                    checked={backupInfra.isBackupDevice === "Yes - PC"}
                />
                <RadioButton
                    name="backupDevice"
                    onChange={handleIsBackupDevice}
                    value="No"
                    label="Skip for now"
                    checked={backupInfra.isBackupDevice === "No"}
                />
            </FlexWrapper>
            </InputWrapper>

            {!isDeviceNone && (
            <>
                {/* Operating System */}
                <InputWrapper label="Operating System">
                <OldSelect
                    value={otherOSBackup ? "Others" : backupInfra.os}
                    handleSelect={handleSelectOS}
                    data={osNamesBackup}
                    placeholder="Choose an option"
                    disabled={isDeviceNone}
                />
                {otherOSBackup && (
                    <Input
                    style={{ marginTop: "1rem" }}
                    onChange={handleOtherOS}
                    placeholder="Enter your Operating system"
                    disabled={isDeviceNone}
                    />
                )}
                </InputWrapper>

                {/* OS Version */}
                <InputWrapper label="OS Version">
                {otherOSBackup ? (
                    <Input
                    style={{ marginTop: "1rem" }}
                    onChange={handleOtherOSVersion}
                    placeholder="Enter your Operating system version"
                    />
                ) : (
                    <>
                    <OldSelect
                        value={otherOSVersionBackup ? "Others" : backupInfra.osVersion}
                        handleSelect={handleSelectOSVersion}
                        data={osVersions}
                        placeholder="Choose an option"
                        disabled={isDeviceNone}
                    />
                    {otherOSVersionBackup && (
                        <Input
                        style={{ marginTop: "1rem" }}
                        onChange={handleOtherOSVersion}
                        placeholder="Enter your Operating system version"
                        disabled={isDeviceNone}
                        />
                    )}
                    </>
                )}
                </InputWrapper>

                {/* Processor */}
                <InputWrapper label="Processor">
                <OldSelect
                    value={otherProcessorBackup ? "Others" : backupInfra.processor}
                    handleSelect={handleProcessor}
                    data={processor}
                    placeholder="Choose an option"
                    disabled={isDeviceNone}
                />
                {otherProcessorBackup && (
                    <Input
                    style={{ marginTop: "1rem" }}
                    onChange={handleOtherProcessor}
                    placeholder="Enter your Processor"
                    disabled={isDeviceNone}
                    />
                )}
                </InputWrapper>

                {/* RAM */}
                <InputWrapper label="RAM">
                <OldSelect
                    value={backupInfra.ram}
                    handleSelect={handleRAM}
                    data={ram}
                    placeholder="Choose an option"
                    disabled={isDeviceNone}
                />
                {otherRAMBackup && (
                    <Input
                    style={{ marginTop: "1rem" }}
                    onChange={handleOtherRAM}
                    placeholder="Enter your RAM"
                    disabled={isDeviceNone}
                    />
                )}
                </InputWrapper>

                {/* Display */}
                <InputWrapper label="Display Setup">
                <OldSelect
                    value={backupInfra.display}
                    handleSelect={handleDisplay}
                    data={display}
                    placeholder="Choose an option"
                    disabled={isDeviceNone}
                />
                {otherDisplayBackup && (
                    <Input
                    style={{ marginTop: "1rem" }}
                    onChange={handleOtherDisplay}
                    placeholder="Enter your Display Setup"
                    disabled={isDeviceNone}
                    />
                )}
                </InputWrapper>

                {/* CPU Screenshot */}
                <CPUFileUpload
                    label="CPU Screenshot"
                    noBorder
                    maxW="100%"
                    pt=".5rem"
                    disabled={isDeviceNone}
                    backupCPUScreenshot={backupCPUScreenshot}
                    setBackupCPUScreenshot={setBackupCPUScreenshot}
                />

                {/* Monitor Screenshot */}
                <MonitorFileUpload
                    label="Monitor Screenshot"
                    noBorder
                    maxW="100%"
                    pt=".5rem"
                    disabled={isDeviceNone}
                    backupMonitorScreenshot={backupMonitorScreenshot}
                    setBackupMonitorScreenshot={setBackupMonitorScreenshot}
                />
            </>
            )}

            <FlexWrapper content="flex-end" mt="2rem">
                <Button disabled={isValidapplicant} onClick={handleGoBack}>Go Back</Button>
                <Button
                    className="filled"
                    disabled={
                        backupInfra.isBackupDevice !== 'No' && (
                            backupInfra.os === '' ||
                            backupInfra.osVersion === '' ||
                            backupInfra.processor === '' ||
                            backupInfra.ram === '' ||
                            backupInfra.display === '' ||
                            !backupCPUScreenshot ||
                            !backupMonitorScreenshot
                        )
                    }
                    onClick={handleNext}
                >
                    Next Step
                </Button>
            </FlexWrapper>
        </StyledScreen>
    )
}

export default RemoteScreenThree